import { Box, Stack, Typography } from '@mui/material';

const GroupedBarChart = ({ data, formatNumber }) => {
  const maxValue = Math.max(...data.flatMap((item) => [item.transactions, item.tickets]), 1);

  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Box sx={{ width: 12, height: 12, borderRadius: 999, backgroundColor: '#0c53b7' }} />
          <Typography variant="caption" color="text.secondary">
            Transactions
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box sx={{ width: 12, height: 12, borderRadius: 999, backgroundColor: '#00a76f' }} />
          <Typography variant="caption" color="text.secondary">
            Tickets
          </Typography>
        </Stack>
      </Stack>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${data.length}, minmax(0, 1fr))`,
          gap: { xs: 1, md: 1.5 },
          alignItems: 'end',
          minHeight: 280
        }}
      >
        {data.map((item) => (
          <Stack key={item.label} spacing={1} alignItems="center" justifyContent="flex-end" sx={{ minWidth: 0 }}>
            <Stack direction="row" spacing={0.75} alignItems="flex-end" sx={{ height: 220 }}>
              <Stack spacing={0.5} alignItems="center" justifyContent="flex-end" sx={{ height: '100%' }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: 10, lineHeight: 1, fontWeight: 700 }}
                >
                  {formatNumber(item.transactions)}
                </Typography>
                <Box
                  sx={{
                    width: { xs: 10, sm: 12, md: 14 },
                    height: `${Math.max((item.transactions / maxValue) * 100, 6)}%`,
                    borderRadius: '10px 10px 4px 4px',
                    background: 'linear-gradient(180deg, #3b82f6, #0c53b7)'
                  }}
                />
              </Stack>
              <Stack spacing={0.5} alignItems="center" justifyContent="flex-end" sx={{ height: '100%' }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: 10, lineHeight: 1, fontWeight: 700 }}
                >
                  {formatNumber(item.tickets)}
                </Typography>
                <Box
                  sx={{
                    width: { xs: 10, sm: 12, md: 14 },
                    height: `${Math.max((item.tickets / maxValue) * 100, 6)}%`,
                    borderRadius: '10px 10px 4px 4px',
                    background: 'linear-gradient(180deg, #34d399, #00a76f)'
                  }}
                />
              </Stack>
            </Stack>
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Stack>
  );
};

export default GroupedBarChart;
